module.exports = __webpack_public_path__ + "img/ic_filters.68bc553e.svg";